import _ from './external-authentication-callback.module.scss'
import React, {useEffect} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {http} from '../../../../../shared/http'
import {inviteCode} from './invite-code'
import {useSharedStore} from '../../../../../state/shared-store-context'
import {PLAUSIBLE_EVENTS, trackPlausibleEvent} from '../../../hooks/use-plausible-analytics'
import {getApiErrorMessage} from '../../../../../shared/api-errors'
import {TriSpinner} from '../../../../../components/tri-spinner'

export const ExternalAuthenticationCallback = ({provider}) => {
    const navigate = useNavigate()
    const {actions} = useSharedStore()
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const returnPath = searchParams.get('state') === 'signup' ? '/auth/signup' : '/auth/login'
        const handBack = (path, error) => navigate(path, {replace: true, state: {externalAuthenticationError: error}})
        if (searchParams.get('error')) return handBack(returnPath, {message: 'Authentication was cancelled or failed'})
        const code = searchParams.get('code')
        if (!code) return handBack(returnPath, {message: 'No authorization code was received'})
        http.post(`/api/v1/auth/${provider}/callback`, {
            code,
            redirectUri: `${window.location.origin}/auth/${provider}/callback`,
            inviteCode: inviteCode.get(),
        }).then(({data}) => {
            if (!data.user) throw new Error('No user received')
            if (data.user.deletedAt) return navigate('/auth/login', {replace: true, state: {deletedAccountUser: data.user}})
            if (data.isNewUser) {
                inviteCode.clear()
                trackPlausibleEvent(PLAUSIBLE_EVENTS.signup, {props: {method: provider}})
            }
            actions.setSessionUser(data.user)
            navigate('/following/map', {replace: true, state: null})
        }).catch(error => {
            const errorCode = error.response?.data?.error
            if (errorCode === 'INVALID_INVITE_CODE') inviteCode.reject(errorCode)
            if (['INVITE_CODE_REQUIRED', 'INVALID_INVITE_CODE'].includes(errorCode))
                return handBack('/auth/signup', {inviteCode: errorCode})
            handBack(returnPath, {message: getApiErrorMessage(error, 'Authentication failed. Please try again.')})
        })
    }, [actions, navigate, provider, searchParams])

    return <div className={_.root}><TriSpinner size={32} color="primary"/></div>
}
